// src/components/PeoplePlan/TheBench/components/WorkflowTable/WorkflowTableHeader.js
import React from "react";
import { FiChevronsUp, FiChevronsDown } from "react-icons/fi";

const WorkflowTableHeader = ({
  column,
  displayName,
  onSort,
  sortColumn,
  sortOrder
}) => {
  const handleClick = () => {
    onSort(column);
  };

  const isActive = sortColumn === column;
  const isAscending = isActive && sortOrder === "asc";
  const isDescending = isActive && sortOrder === "desc";

  return (
    <th onClick={handleClick}>
      {displayName}
      <FiChevronsUp
        className={`sort-icon ${isAscending ? "active" : ""}`}
      />
      <FiChevronsDown
        className={`sort-icon ${isDescending ? "active" : ""}`}
      />
    </th>
  );
};

export default WorkflowTableHeader;